export const isAnyItem = (item: { item?: string }): boolean => !!(item?.item && item.item !== 'assembly')
